import React from "react";
import "./CriteriaView.css";
import Menu from "@material-ui/core/Menu";
import Codebook from "@safecv/assets/Images/codebook.svg";
import ShowMoreCodebookModal from "./ShowMoreCodebookModal";
import CopyIcon from "../../../assets/Images/copy_icon.svg";
import { copyToClipboard } from "@safecv/shared/stringUtils";

const CodebookMenu = ({ information }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <img src={Codebook} alt="codebook" onClick={handleClick} />
      <Menu
        id="menu"
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            borderRadius: "5px",
          },
        }}
        className="codebook-menu"
      >
        <div className="codebook-menulist">
          <div className="tooltip-codebook-header">CODEBOOK</div>
          <div>
            <div style={{ display: "flex" }}>
              <div className="tooltip-codebook-content-heading">
                {information?.heading}
              </div>
              <div className="tooltip-codebook-content-copy">
                <img
                  src={CopyIcon}
                  alt="Copy Icon"
                  className="pointer-css"
                  onClick={() => copyToClipboard(information?.heading +" : "+information?.details)}
                />
              </div>
            </div>

            <div className="tooltip-codebook-content-details">
              {information?.details}
            </div>

            <ShowMoreCodebookModal
              handleCopy={copyToClipboard}
              handleCloseMenu={handleClose}
              heading={information?.heading}
              details={information?.details}
            />
          </div>
        </div>
      </Menu>
    </>
  );
};

export default CodebookMenu;